import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class ReportPresenter extends EntityPresenter {
  static urn = 'statistics'

  static navOptions(key = 'statistics') {
    const routes = {
      statistics: {
        icon: 'download',
        pageRoutes: ['statistic'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(ReportPresenter)
